/**
 * -----------------------------------------------------------------------------------------------------------
 * gs table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_TABLE_DATA = 'SET_TABLE_DATA'
export const SET_TABLE_DATAS = 'SET_TABLE_DATAS'
export const SET_TABLE_PAGINATION = 'SET_TABLE_PAGINATION'
export const SET_TABLE_PAGINATIONS = 'SET_TABLE_PAGINATIONS'
export const SET_TABLE_QUERIES = 'SET_TABLE_QUERIES'

/**
 * -----------------------------------------------------------------------------------------------------------
 * invoice module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_INVOICE_HELPERS = 'GET_INVOICE_HELPERS'
export const SET_INVOICE = 'SET_INVOICE'

/**
 * -----------------------------------------------------------------------------------------------------------
 * gs role module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_ROLES = 'GET_ALL_ROLES'
export const GET_ROLE = 'GET_ROLE'

/**
 * -----------------------------------------------------------------------------------------------------------
 * gs admin module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_ADMINS = 'GET_ALL_ADMINS'

/**
 * -----------------------------------------------------------------------------------------------------------
 * gs permission module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_PERMISSIONS = 'GET_ALL_PERMISSIONS'
export const SET_PERMISSION = 'SET_PERMISSION'
export const SET_PERMISSION_HELPERS = 'SET_PERMISSION_HELPERS'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Carrier module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_CARRIERS = 'GET_ALL_CARRIERS'
export const GET_ALL_CARRIERS_ZH_COD = 'GET_ALL_CARRIERS_ZH_COD'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Compare module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_CROSS_CHECKS_HELPERS = 'GET_CROSS_CHECKS_HELPERS'
export const GET_COMPARE_HELPERS = 'GET_COMPARE_HELPERS'
export const GET_COMPARE_FEE_HELPERS = 'GET_COMPARE_FEE_HELPERS'

/**
 * -----------------------------------------------------------------------------------------------------------
 * receipt module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_RECEIPT = 'SET_RECEIPT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * account module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ACCOUNT = 'GET_ACCOUNT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * user module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_USER = 'GET_USER'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Shipment module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SHIPMENT_FAIL = 'SHIPMENT_FAIL'
export const GET_SHIPMENT_HELPERS = 'GET_SHIPMENT_HELPERS'
export const GET_SHIPMENT_STATUS_FILTERS = 'GET_SHIPMENT_STATUS_FILTERS'
export const SET_SHIPMENT = 'SET_SHIPMENT'
export const NEW_SHIPMENT = 'NEW_SHIPMENT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * gs affiliate module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_AFFILIATES = 'GET_ALL_AFFILIATES'
export const GET_AFFILIATE = 'GET_AFFILIATE'

/**
 * -----------------------------------------------------------------------------------------------------------
 * bank module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_BANKS = 'SET_BANKS'

/**
 * -----------------------------------------------------------------------------------------------------------
 * City module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_CITY = 'GET_ALL_CITY'

/**
 * -----------------------------------------------------------------------------------------------------------
 * District module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_DISTRICT = 'GET_ALL_DISTRICT'
export const GET_DISTRICT_TO = 'GET_DISTRICT_TO'
export const GET_DISTRICT_FROM = 'GET_DISTRICT_FROM'
export const SET_LOADED_DISTRICT_BY_CITY_CODE = 'SET_LOADED_DISTRICT_BY_CITY_CODE'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Ward module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_WARD = 'GET_ALL_WARD'
export const GET_WARD_TO = 'GET_WARD_TO'
export const GET_WARD_FROM = 'GET_WARD_FROM'
export const SET_LOADED_WARD_BY_DISTRICT_CODE = 'SET_LOADED_WARD_BY_DISTRICT_CODE'
export const SET_LOADED_WARD_BY_DISTRICT_ID = 'SET_LOADED_WARD_BY_DISTRICT_ID'
export const GET_WARD = 'GET_DISTRICT'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js